<template>
  <v-dialog v-model="dialog" width="500px">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" class="mb-2 primary" depressed> New Chat </v-btn>
    </template>
    <v-card tile>
      <v-card-title>New Chat</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5 pb-5">
        <v-form v-model="isValid" ref="form">
          <v-text-field
            :dense="$root.dense"
            v-model="name"
            :rules="rules"
            label="Name"
            outlined
          ></v-text-field>
          <phone v-model="phone" label="Phone"></phone>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" @click="dialog = false" text>Cancel</v-btn>
        <v-btn color="success" @click="submit()" text>Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDate } from "../../assets/js/common";
import { chat_list } from "../../assets/js/firebase";
import { FIELD } from "../../assets/js/rules";
import Phone from "../inputs/Phone.vue";
export default {
  components: {
    Phone,
  },
  data() {
    return {
      name: "",
      rules: FIELD,
      phone: "",
      isValid: false,
      dialog: false,
    };
  },
  methods: {
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      let { phone, name } = vm;
      if (!vm.isValid) return;
      try {
        vm.$root.loader = true;
        let normalized ;
        if(phone.length > 10){
          if(phone.length == 11) normalized = phone.slice(1);
          if(phone.length == 12) normalized = phone.slice(2);
        }
        let lower_name = name.toLowerCase();
        let doc = { phone, name, lower_name, updated_at: getDate(), unread: 0 };
        let snap = await chat_list.doc(phone).get();
        if(!snap.exists && normalized?.length == 10){
          snap = await chat_list.doc(normalized).get();
        }
        if (snap.exists) {
          let item = snap.data();
          item.id = snap.id;
          vm.$emit("click", item);
        } else {
          await chat_list.doc(phone).set(doc);
          doc.id = phone;
          vm.$emit("click", doc);
        }
        vm.dialog = false;
        vm.$refs.form.reset();
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
  },
};
</script>
